let isMobileToggleBound = false;


function relatedProperty() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.property_item .property_item__name a').each(function (){
            $(this).attr('aria-expanded', 'true');
        });
        $('.property_item .property_item__content').each(function (){
            $(this).attr('aria-hidden', 'false');
        });
        $('body').on('click.mobileToggle', '.property_item__name > a', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).attr('aria-expanded', $(this).hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings('.property_item__content').attr('aria-hidden', $(this).hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150);
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.property_item .property_item__name').each(function (){
            $(this).removeAttr('aria-expanded');
        });
        $('.property_item .property_item__content').each(function (){
            $(this).removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}



$(document).ready(function () {
    relatedProperty();
    $(window).on('resize', relatedProperty);
});